import {
  ANNOTATION_RULES_UNLIMITED_GRANT,
  ANNOTATIONS_GRANT,
  AUDIT_HISTORY_GRANT,
  BACKFILL_GRANT,
  BRIEFING_WEEKS_UNLIMITED_GRANT,
  CUSTOM_INSTANCE_GRANT,
  GIVEAWAYS_GRANT,
  GIVEAWAYS_REPEAT_GRANT,
  HISTORY_VIEW_UNLIMITED_GRANT,
  INSIGHTS_EXPERIMENTS_GRANT,
  INSIGHTS_FINDINGS_GRANT,
  INSIGHTS_ALERTS_GRANT,
  INSIGHTS_INBOX_GRANT,
  LEVELING_ADVANCED_GRANT,
  LEVELING_GRANT,
  LEVELING_MEMBER_CARDS_GRANT,
  LEVELING_RECOUNT_GRANT,
  LEVELING_REWARD_CARDS_GRANT,
  LEVELING_RULES_UNLIMITED_GRANT,
  LIMIT_ANNOTATION_RULES,
  LIMIT_BRIEFING_ITEMS,
  LIMIT_BRIEFING_WEEKS,
  LIMIT_HISTORY_VIEW_DAYS,
  LIMIT_IMAGES,
  LIMIT_LEVELING_RULES,
  LIMIT_PERKS,
  LIMIT_PERK_CONDITIONS,
  PERKS_UNLIMITED_GRANT,
  LIMIT_RATE_PER_MINUTE,
  LIMIT_SAVED_VIEWS,
  LIMIT_TEAM_POLICIES,
  PULSE_GRANT,
  TEAM_CUSTOM_POLICIES_GRANT,
  TEAM_POLICIES_GRANT,
  TEAM_POLICIES_UNLIMITED_GRANT,
  TEAM_ROLE_POLICIES_GRANT,
} from "./entitlement.ts";

export const MODULES = ["analytics", "intelligence", "rewards", "campaigns", "workspace"] as const;

export type Module = (typeof MODULES)[number];

export const GRANT_MODULE = {
  [LIMIT_HISTORY_VIEW_DAYS]: "analytics",
  [HISTORY_VIEW_UNLIMITED_GRANT]: "analytics",
  [LIMIT_SAVED_VIEWS]: "analytics",
  [PULSE_GRANT]: "intelligence",
  [INSIGHTS_FINDINGS_GRANT]: "intelligence",
  [INSIGHTS_EXPERIMENTS_GRANT]: "intelligence",
  [LIMIT_BRIEFING_ITEMS]: "intelligence",
  [LIMIT_BRIEFING_WEEKS]: "intelligence",
  [BRIEFING_WEEKS_UNLIMITED_GRANT]: "intelligence",
  [INSIGHTS_INBOX_GRANT]: "intelligence",
  [INSIGHTS_ALERTS_GRANT]: "intelligence",
  [ANNOTATIONS_GRANT]: "intelligence",
  [LIMIT_ANNOTATION_RULES]: "intelligence",
  [ANNOTATION_RULES_UNLIMITED_GRANT]: "intelligence",
  [LEVELING_GRANT]: "rewards",
  [LEVELING_ADVANCED_GRANT]: "rewards",
  [LIMIT_LEVELING_RULES]: "rewards",
  [LEVELING_RULES_UNLIMITED_GRANT]: "rewards",
  [LIMIT_PERKS]: "rewards",
  [PERKS_UNLIMITED_GRANT]: "rewards",
  [LIMIT_PERK_CONDITIONS]: "rewards",
  [LEVELING_RECOUNT_GRANT]: "rewards",
  [LEVELING_MEMBER_CARDS_GRANT]: "rewards",
  [LEVELING_REWARD_CARDS_GRANT]: "rewards",
  [LIMIT_IMAGES]: "rewards",
  [GIVEAWAYS_GRANT]: "campaigns",
  [GIVEAWAYS_REPEAT_GRANT]: "campaigns",
  [BACKFILL_GRANT]: "workspace",
  [LIMIT_RATE_PER_MINUTE]: "workspace",
  [CUSTOM_INSTANCE_GRANT]: "workspace",
  [TEAM_POLICIES_GRANT]: "workspace",
  [TEAM_ROLE_POLICIES_GRANT]: "workspace",
  [TEAM_CUSTOM_POLICIES_GRANT]: "workspace",
  [TEAM_POLICIES_UNLIMITED_GRANT]: "workspace",
  [LIMIT_TEAM_POLICIES]: "workspace",
  [AUDIT_HISTORY_GRANT]: "workspace",
} as const satisfies Readonly<Record<string, Module>>;

export type GrantKey = keyof typeof GRANT_MODULE;

export const modulePath = (tenantId: string, module: Module, rest = ""): string =>
  rest === "" ? `/t/${tenantId}/${module}` : `/t/${tenantId}/${module}/${rest}`;

export const billingPath = (tenantId: string): string =>
  modulePath(tenantId, "workspace", "billing");

export type GrantOf<M extends Module> = {
  [K in GrantKey]: (typeof GRANT_MODULE)[K] extends M ? K : never;
}[GrantKey];
